import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { MultipleAccordionWithAudioProps } from "./types";
import {
  PropertyDefinition,
  PropertyMappingType,
} from "app/library/layout-builder";

export class MultipleAccordionWithAudioDefinitions extends CmsReactComponent<MultipleAccordionWithAudioProps> {

  static schemaName = "multiple-accordion-with-audio";
  // groups?: Array<{
  //   title: string,
  //   content: Array<{
  //     title: string,
  //     audio: string,
  //     content: string,
  //   }>;
  // }>;
  static propertyDefinitions: PropertyDefinition[] = [
    {
      name: "groups",
      mapping: {
        type: PropertyMappingType.ArrayData,
        keys: [
          {
            name: "title",
            mapping: {
              type: PropertyMappingType.String
            },
            text: "Grup Başlığı"
          },
          {
            name: "content",
            mapping: {
              type: PropertyMappingType.ArrayData,
              keys: [
                {
                  name: "title",
                  mapping: {
                    type: PropertyMappingType.String
                  },
                  text: "Alt grup Başlığı"
                },
                {
                  name: "audio",
                  mapping: {
                    type: PropertyMappingType.File
                  },
                  text: "Alt grup sesi"
                },
                {
                  name: "content",
                  mapping: {
                    type: PropertyMappingType.Html
                  },
                  text: "Alt grup içeriği"
                },
              ]
            },
            text: "Alt İçerikler"
          },
        ]
      },
      text: "İçerik grupları",
    },
  ];
}
